import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ClientLogService } from './client-log.service';

/** Catches unhandled client errors and forwards them to the backend log sink. */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private readonly injector: Injector) {}

  handleError(error: any): void {
    try {
      const message = error?.message ?? String(error);
      this.injector.get(ClientLogService).log('error', message, error?.stack);
    } catch {
      // Logging must never mask the original error.
    }
    console.error(error);
  }
}
